import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { thunderstormATSGroups } from '../../consts.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_V_L } from '../Layouts/index.js';
import { TS_AppTools } from '../TS_AppTools/index.js';
import './ATS_Label.scss';
import { Label } from './Label.js';
export class ATS_Label extends ComponentSync {
    static Screen = {
        key: 'ats-ts-label',
        name: 'Label',
        group: thunderstormATSGroups,
        renderer: this,
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    //######################### Logic #########################
    getTests = () => {
        return [
            { label: 'Short Title - With tooltip', tooltip: 'Tooltip for short title' },
            { label: 'Short Title - Without tooltip ' },
            { label: 'Long Title - With tooltip - asdasdasdasdasdasd', tooltip: 'Tooltip for Long title' },
            { label: 'Long Title - Without tooltip - asdasdasdasdasdasd' },
            { label: 'Long Title - With long tooltip - asdasdasdasdasdasd', tooltip: 'Tooltip for Long title - asdasdasdasdasdasd' },
        ];
    };
    //######################### Render #########################
    render() {
        const tests = this.getTests();
        return _jsxs(LL_V_L, { id: 'ats__label', children: [TS_AppTools.renderPageHeader('Label'), _jsx(LL_V_L, { className: 'ats__label__labels', children: tests.map((test, i) => _jsx(Label, { tooltip: test.tooltip, children: test.label }, i)) })] });
    }
}
//# sourceMappingURL=ATS_Label.js.map